import type { ParsedAddress } from "./google-places";

export const PLACES_API_CONFIG = {
  apiKey: "AIzaSyC9fWHC_daJJZWM8W-N8zDB5gJEcsetKfg",
  autocompleteUrl: "https://places.googleapis.com/v1/places:autocomplete",
  placeDetailsUrl: "https://places.googleapis.com/v1/places",
  fieldMask: "id,formattedAddress,addressComponents",
  defaultDebounceMs: 300,
  defaultMinQueryLength: 2,
  staleTime: 5 * 60 * 1000,
  maxAddressLength: 100,
  addressSplitThreshold: 50,
} as const;

export const DEFAULT_ADDRESS_TYPES = ["street_address", "premise", "subpremise"] as const;

export const ADDRESS_COMPONENT_TYPE_MAPPING = {
  street_number: { field: "streetNumber", precedence: 1 },
  route: { field: "streetName", precedence: 1 },
  locality: { field: "city", precedence: 1 },
  sublocality_level_1: { field: "city", useShortText: true, precedence: 2 },
  sublocality: { field: "city", useShortText: true, precedence: 3 },
  administrative_area_level_3: { field: "city", precedence: 4 },
  administrative_area_level_2: { field: "city", precedence: 5 },
  administrative_area_level_1: { field: "state", useShortText: true, precedence: 1 },
  country: { field: "country", useShortText: true, precedence: 1 },
  postal_code: { field: "postalCode", precedence: 1 },
} as const satisfies Record<
  string,
  {
    field: keyof ParsedAddress;
    precedence: number;
    useShortText?: boolean;
  }
>;
